import React from "react";
import Lottie from "lottie-react";
import checkedAnimation from "../checked-without-animation.json";

const StepCompleted = () => {
  console.log(`step completed!`);
  return (
    <div className="flex justify-center mx-auto mt-9 items-center">
      <div className="text-center">
        <p className="font-bold text-xl max-w-2/5 capitalize ml-32">
          Your application has been successfully submitted to COC. COC team will
          quickly contact you.
        </p>
        <div className="mx-auto" style={{ width: "400px", height: "400px" }}>
          <Lottie loop={false} animationData={checkedAnimation} />
        </div>
      </div>
    </div>
  );
};

export default StepCompleted;
